'use strict';

var _ = require('lodash');
var RomSummaryDateRangeChartController = function RomSummaryDateRangeChartController($scope, dataService, dataPreparationService, dataRetrieverConstantsService, BrushSelectionFilter, ConfigurationService) {
  $scope.isChartVisible = true;
  $scope.data = [];
  $scope.initData = undefined;
  $scope.maxSelectSummaryWeeks = ConfigurationService.getROMMaxSelectSummaryWeeks();
  $scope.toggleChartVisibility = function () {
    $scope.isChartVisible = !$scope.isChartVisible;
  };
  $scope.getData = function () {
    return dataService.getData(dataRetrieverConstantsService.ROM_SUMMARY_SCREEN, dataRetrieverConstantsService.ROM_SUMMARY_MODE, 'summary-chart');
  };
  $scope.groupData = dataPreparationService.groupData('week');
  $scope.reloadCurrentChart = function () {
    return $scope.loadData().then($scope.redrawCurrentChart);
  };
  $scope.redrawCurrentChart = function () {
    var chartData = $scope.prepareDataForChart();
    $scope.renderChart(chartData, $scope.calculateInitialSelection(chartData));
  };
  $scope.setDataOnScope = function (data) {
    if (!$scope.initData) {
      $scope.data = data;
      $scope.initData = data;
    } else {
      $scope.data = dataPreparationService.mergeData($scope.initData, data, 'week');
    }
  };
  $scope.loadData = function () {
    return $scope.getData().then(dataPreparationService.setLabels).then($scope.groupData).then($scope.setDataOnScope);
  };
  $scope.prepareDataForChart = function () {
    switch ($scope.chartView) {
      case 'OPPORTUNITY_TREND':
        return dataPreparationService.prepareForTrendOpportunity($scope.data);
      case 'MIN_ACT_MAX_REVENUE':
        return dataPreparationService.prepareForMinActMaxRevenue($scope.data);
      case 'DMND_PAX':
        return dataPreparationService.prepareForDemandAndPaxVsOptimal($scope.data);
      case 'AVG_FARE':
        return dataPreparationService.prepareForAvgFareVsOptimal($scope.data);
      case 'DMND_WEIGHT':
        return dataPreparationService.prepareForDemandWeightedOpenPercentVsOptimal($scope.data);
    }
  };
  $scope.getFilterComponentBrush = function (ranges) {
    return new BrushSelectionFilter('filter-component', rangesToOptGroupWeekArrays(ranges));
  };
  function rangesToOptGroupWeekArrays(ranges) {
    var dataLength = $scope.data.length;
    return _.map(ranges, function (r) {
      r = r || [];
      var toIndex = r[1] > dataLength ? dataLength : r[1];
      return {
        optGroupWeek: _.chain($scope.data).slice(r[0], toIndex).map('optGroupWeek').value()
      };
    });
  }
  $scope.$on('brush-filter:filterApplied', function (event, filter) {
    if (filter.filterType !== 'filter-component') {
      $scope.reloadCurrentChart();
    }
  });
  $scope.$on(dataRetrieverConstantsService.ROM_SUMMARY_SCREEN + ':flowTypeChanged', function () {
    $scope.reloadCurrentChart();
  });
};
RomSummaryDateRangeChartController.$inject = ['$scope', 'RomSummaryChartsDataService', 'RomSummaryChartsDataPreparationService', 'DataRetrieverConstantsService', 'BrushSelectionFilterFactory', 'ConfigurationService'];
module.exports = RomSummaryDateRangeChartController;